var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3335 29.3333H8.00016C7.29292 29.3333 6.61464 29.0523 6.11454 28.5522C5.61445 28.0521 5.3335 27.3738 5.3335 26.6666L5.3335 5.33325C5.3335 4.62601 5.61445 3.94773 6.11454 3.44763C6.61464 2.94754 7.29292 2.66658 8.00016 2.66658H24.0002C24.7074 2.66658 25.3857 2.94754 25.8858 3.44763C26.3859 3.94773 26.6668 4.62601 26.6668 5.33325V19.9999M17.3335 29.3333L26.6668 19.9999M17.3335 29.3333L17.3335 19.9999H26.6668",
    stroke: "black",
    strokeOpacity: 0.3,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/File.40008aa6ebfa98cbee170088ca78b49f.svg";
export { ForwardRef as ReactComponent };